'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
const filter = require('lodash/filter');
const uuid = require('uuid');
import { Card } from 'react-bootstrap';

const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
const AdminLtiAssignmentsStore = require('../../stores/admin/lti_assignments_store');
const AssignmentActions = require('../../actions/AssignmentActions');
import LoadingMainContent from '../loading/LoadingMainContent';
import SortableTableClassic from '../table/SortableTableClassic';
import DefinitionListMapped from '../common/definition_list_mapped';
import WarningBox from '../common/WarningBox';

const propTypes = {};
const defaultProps = {};

class AdminLTIAssignmentsView extends React.Component {
	constructor(props) {
        super(props);
		this.state = {
			userStoreState: AdminGlobalUserStore.getState(),
			ltiAssignmentStoreState: AdminLtiAssignmentsStore.getState(),
            selectedUserId: null,
            selectedAssignmentHash: null,
            actionId: null
		};

        this.onUserClick = this.onUserClick.bind(this);
        this.onAssignmentClick = this.onAssignmentClick.bind(this);

        this.unsubscribes = [
            AdminGlobalUserStore.listen(this.onAdminGlobalUserStoreChange.bind(this)),
            AdminLtiAssignmentsStore.listen(this.onLtiAssignmentsStoreChange.bind(this))
        ];
	}

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onAdminGlobalUserStoreChange(state) {
        this.setState({ userStoreState: state });
    }

    onLtiAssignmentsStoreChange(state) {
        this.setState({ ltiAssignmentStoreState: state });
    }

    onUserClick(e, userId) {
        let actionId = null;
        let updatedState = { selectedUserId: userId };
        const userNotLoaded = !this.state.ltiAssignmentStoreState.assignments[userId];
        if (userNotLoaded) {
            actionId = uuid.v4();
            updatedState.actionId = actionId;
        }

        this.setState(updatedState, () => {
            if (userNotLoaded) {
                AssignmentActions.getLtiAssignmentsForUser(actionId, { userId: userId });
            }
        });
    }

    onAssignmentClick(e, assignmentHash) {
        const assn = find(this.state.ltiAssignmentStoreState.assignments[this.state.selectedUserId], { hash: assignmentHash }); //temporary
        const assignmentNotLoaded = !this.state.ltiAssignmentStoreState.assignmentStats[assignmentHash];
        let actionId = null;
        let updatedState = {
            selectedAssignmentHash: assignmentHash,
            selectedAssignment: assn
        };

        if (assignmentNotLoaded) {
            actionId = uuid.v4();
            updatedState.actionId = actionId;
        }

        this.setState(updatedState, () => {
            if (assignmentNotLoaded) {
                AssignmentActions.getLtiAssignmentStats(actionId, {assignmentHash: assignmentHash});
            }
        });
    }

	render() {
        return (
            <WarningBox>Disabled: Requires rewrite to account for paginated user endpoint.</WarningBox>
        );

		/*if (!this.state.userStoreState.initialized) {
			return <LoadingMainContent/>
		}

        const partnerUsers = filter(this.state.userStoreState.authors, (author) => { return !!author.key; })

        return (
            <div>
                <SortableTableClassic
                    key="t-user"
                    title="Partner Users"
                    onRowClick={this.onUserClick}
                    rows={partnerUsers}
                    selectedRowKey={this.state.selectedUserId}
                    columns={[
                            {
                                displayName: 'ID',
                                key:'id',
                                size: 1,
                                type: 'int'
                            },
                            {
                                displayName: 'First Name',
                                key:'first_name',
                                size: 1,
                                type: 'string'
                            },
                            {
                                displayName: 'Partner Name',
                                key:'partner_name',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Email',
                                key:'email',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Assignment Count',
                                key:'assignment_count',
                                size: 1,
                                type: 'int'
                            },
                            {
                                displayName: 'External Users',
                                key:'external_user_count',
                                size: 1,
                                type: 'int'
                            },
                        ]}
                />
                {(!!this.state.selectedUserId) &&
                    <SortableTableClassic
                        key="t-assn"
                        title="Assignments"
                        onRowClick={this.onAssignmentClick}
                        rows={this.state.ltiAssignmentStoreState.assignments[this.state.selectedUserId]}
                        selectedRowKey={this.state.selectedAssignmentHash}
                        uniqueRowKey="hash"
                        dateFormat="YYYY-MM-DD HH:mm:ss"
                        columns={[
                                {
                                    displayName: 'ID',
                                    key:'id',
                                    size: 1,
                                    type: 'int'
                                },
                                {
                                    displayName: 'Name',
                                    key:'name',
                                    size: 2,
                                    type: 'string'
                                },
                                {
                                    displayName: 'Student Count',
                                    key:'student_count',
                                    size: 1,
                                    type: 'int'
                                },
                                {
                                    displayName: 'Activity ID',
                                    key:'activity_id',
                                    size: 1,
                                    type: 'int'
                                },
                                {
                                    displayName: 'Activity Name',
                                    key:'activity_name',
                                    size: 2,
                                    type: 'string'
                                },
                                {
                                    displayName: 'Template',
                                    key:'template_name',
                                    size: 1,
                                    type: 'string'
                                },
                                {
                                    displayName: 'Create Date',
                                    key:'create_date',
                                    size: 2,
                                    type: 'date'
                                },
                                {
                                    displayName: 'RLID',
                                    key:'third_party_id',
                                    size: 1,
                                    type: 'string'
                                }
                            ]}
                    />
                }

                {(!!this.state.selectedAssignment) &&
                    <Card body bg="light">
                        <h2 className="view-title">Assignment Details</h2>
                            <DefinitionListMapped
                                className="inline-list-elems list-spaced"
                                definitions={this.state.selectedAssignment}
                            />
                    </Card>
                }

                {(!!this.state.selectedAssignmentHash && !!this.state.ltiAssignmentStoreState.assignmentStats[this.state.selectedAssignmentHash]) &&
                    <Card body bg="light">
                        <h2 className="view-title">Assignment Statistics</h2>
                            <DefinitionListMapped
                                className="inline-list-elems list-spaced"
                                definitions={this.state.ltiAssignmentStoreState.assignmentStats[this.state.selectedAssignmentHash]}
                            />
                    </Card>
                }
            </div>
        )*/
	}
}

AdminLTIAssignmentsView.propTypes = propTypes;
AdminLTIAssignmentsView.defaultProps = defaultProps;

export default AdminLTIAssignmentsView;